import BaseService from '../../BaseService.js';

export default class BerechtigungService extends BaseService {
  constructor(wohnobjektId) {
    super(`wohnobjekte/${wohnobjektId}/berechtigungen`)
  }
}
